export default __webpack_public_path__ + "static/media/1826.d6d39f9c.png";